import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PROPERTY_MANAGEMENT_SOFTWARE_GET_LIST } from 'api/actionTypes';

export default async function getList({ state, apiClient }) {
  const path = ['propertyManagementSoftware', 'list'];
  if (state.get(path)) {
    return;
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PROPERTY_MANAGEMENT_SOFTWARE_GET_LIST,
    state: state,
    onSuccess(propertyManagementSoftwareList) {
      typeCheck('propertyManagementSoftwareList::Array', propertyManagementSoftwareList);
      state.set(path, propertyManagementSoftwareList);
      return propertyManagementSoftwareList;
    },
  });
}
